import styled from 'styled-components';

export const Tbody = styled.tbody``;
